import { Button, Ui } from '@silvertours/front-shared';
import { useTranslations } from 'next-intl';
import { LockIcon, UserIcon } from './LoginButton.styles';
import { LoggedInActions } from '../LoggedInActions';
import { useLogin } from '../../../LoginForm';

type Props = {
  onClick?: () => void;
};

const LoginButton = ({ onClick }: Props) => {
  const { isLoggedIn, setShowLogin } = useLogin();
  const t = useTranslations('features.navigationLegacy.login');

  const handleLoginClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
    setShowLogin(true);
  };

  if (!isLoggedIn) {
    return (
      <Button
        key="logged-out-actions"
        icon={<LockIcon />}
        variant="secondary"
        size="small"
        onClick={handleLoginClick}
        data-testid="accountMenuButton"
      >
        {t('menu.button.loggedOut')}
      </Button>
    );
  }

  return (
    <Ui.Popover
      key="logged-in-actions"
      button={{
        as: Button,
        icon: <UserIcon />,
        variant: 'secondary',
        size: 'small',
        children: t('menu.button.loggedIn'),
        'data-testid': 'accountMenuButton',
      }}
    >
      <Ui.PopoverPanel>
        <LoggedInActions />
      </Ui.PopoverPanel>
    </Ui.Popover>
  );
};

export { LoginButton };
